import React, { useState } from 'react'
import images from '../../constants/images';
import { FaBars, FaTimes } from 'react-icons/fa'
import {Link} from 'react-router-dom'
import './NavbarStyles.css'

const Navbar = () => {
    const [nav, setNav] = useState(false)
    const handleNav = () => setNav(!nav)


    return (
        <div name='top' className='navbar'>
            <div className="container">
                <div className="logo">
                <Link to='/'><img src={images.inkanto} alt="app__logo" /></Link>
                    <h1></h1>
                </div>

                <ul className={nav ? 'nav-menu active' : 'nav-menu'}>
                    <li><Link to='/'>Home</Link></li>
                    <li><Link to='/aboutme'>About Me</Link> </li>
                    <li><Link to='/services'>Services</Link></li>
                    <li><Link to='/gallery'>Gallery</Link></li>
                    <li><Link to='/contact'>Contact</Link></li>
                    
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {/*<button>Closed</button>*/}
                </ul>
                <div className="hamburger" onClick={handleNav}>
                    {!nav ? (<FaBars className='icon' />) : (<FaTimes className='icon' />)}
                </div>
            </div>
        </div>
    )
}

export default Navbar